import { FC } from 'react'

import { IEspTypeShare } from '../../../../lib/getEspDashboardStats'

import styles from './EspTypeBars.module.scss'

interface IEspTypeBarsProps {
  /** Already bucketed and percented — see lib/getEspDashboardStats. */
  items: IEspTypeShare[]
}

/** Activity breakdown by type as labelled progress bars (wireframe screen 6). */
export const EspTypeBars: FC<IEspTypeBarsProps> = ({ items }) => (
  <div className={styles.root}>
    {items.map((item) => (
      <div key={item.key} className={styles.row}>
        <div className={styles.head}>
          <span>{item.label}</span>
          <span className={styles.percent}>{item.percent}%</span>
        </div>
        <div className={styles.bar}>
          <i className={styles.fill} style={{ width: `${item.percent}%` }} />
        </div>
      </div>
    ))}
  </div>
)

EspTypeBars.displayName = 'EspTypeBars'
